'use client'

export { InternalServerErrorPage as default } from '@/feature/error/pages/internal-server-error-page/InternalServerErrorPage.client'
